import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Modal, Form } from 'react-bootstrap'
import { toast } from '@CommonComponents/toast'
import { client } from '@Utils'
import { useStateValue } from '@State'

export const EditIssuerModal = ({ show, toggle, issuer }) => {
  const [currentState, dispatch] = useStateValue()
  const [stateObj, setStateObj] = useState(issuer)

  useEffect(() => {
    if (issuer) {
      setStateObj(issuer);
    }
  }, [issuer]);


  const commitStateObject = async () => {
    try {
      // switch data for mydata for update; See Item structure in dserv project
      const fullStateObj = { ...stateObj, mydata: stateObj.data }
      const resp = await client.post(
        `/account/admin_lti13.editIssuer/-/${currentState.issuer.id}`,
        fullStateObj
      )
      toast.success("Successfully edited the issuer.")
      dispatch({ type: 'updateIssuer', issuer: resp.data.issuer })
    } catch (err) {
      console.log(err)
      let errMsg = "There was an error trying to update the Platform Instance."
      if (err.response) {
        errMsg = `Error: ${err.response.data.error}`
      }
      toast.error(errMsg)
    } finally {
      toggle(!show)
    }
  }

  const handleDataChange = e => {
    const { data } = { ...stateObj }

    const { name, value, type, checked } = e.target
    if (type === 'checkbox') {
      data[name] = checked
    } else {
      data[name] = value
    }
    const nextStateObj = { ...stateObj, data }
    setStateObj(nextStateObj)
  }
  const handleNewJWKurlChange = e => {
    const { value } = e.target
    const nextStateObj = { ...stateObj, new_jwk_url: value }
    setStateObj(nextStateObj)

  }

  const helpTextStyle = {
    fontSize: "0.8em",
    color: "#6B5400"
  }
  return (
    <Modal show={show} onHide={() => toggle(!show)}>
      <Modal.Header closeButton>
        <Modal.Title>Edit Platform Instance</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group controlId="guid">
          <Form.Label>Guid:</Form.Label>
          <Form.Control
            type="text"
            onChange={handleDataChange}
            name="guid"
            disabled
            value={stateObj && stateObj.data.guid ? stateObj.data.guid : ''}
          />
        </Form.Group>
        <Form.Group controlId="productfamilycode">
          <Form.Label>Product Family Code </Form.Label>
          <Form.Control
            type="text"
            onChange={handleDataChange}
            name="productfamilycode"
            disabled
            value={stateObj && stateObj.data.product_family_code ? stateObj.data.product_family_code : ''}
          />
        </Form.Group>
        <Form.Group controlId="version">
          <Form.Label>Version</Form.Label>
          <Form.Control
            type="text"
            onChange={handleDataChange}
            name="version"
            disabled
            value={stateObj && stateObj.data.version ? stateObj.data.version : ''}
          />
        </Form.Group>
        <Form.Group controlId="name">
          <Form.Label>Name</Form.Label>
          <Form.Control
            type="text"
            onChange={handleDataChange}
            name="name"
            value={stateObj && stateObj.data.name ? stateObj.data.name : ''}
          />
        </Form.Group>
        <Form.Group controlId="auth_url">
          <Form.Label>Authentication URL</Form.Label>
          <Form.Control
            type="text"
            onChange={handleDataChange}
            name="auth_url"
            value={stateObj && stateObj.data.auth_url ? stateObj.data.auth_url : ''}
          />
        </Form.Group>
        <Form.Group controlId="token_url">
          <Form.Label>Token URL</Form.Label>
          <Form.Control
            type="text"
            onChange={handleDataChange}
            name="token_url"
            value={stateObj && stateObj.data.token_url ? stateObj.data.token_url : ''}
          />
        </Form.Group>
        <Form.Group controlId="aud">
          <Form.Label>JWK Audience Claim</Form.Label>
          <Form.Control
            type="text"
            onChange={handleDataChange}
            name="aud"
            value={stateObj && stateObj.data.aud ? stateObj.data.aud : ''}
          />
          <div style={helpTextStyle}>
            Sets the audience claim when signing JWKs. Generally is the same as the Token URL but not always. Do not modify this unless you understand what this means.
          </div>
        </Form.Group>
        <Form.Group>
          <Form.Label>New JWK URLs</Form.Label>
          <Form.Control
            value={stateObj && stateObj.new_jwk_url ? stateObj.new_jwk_url : ''}
            onChange={handleNewJWKurlChange} type='text' name="new_jwk_url" />
          <div style={helpTextStyle}>
            Add one URL for a new JWK to add to the issuer.keystore
          </div>
        </Form.Group>
        <Form.Group controlId="useEmailLogin">
          <Form.Label>Use Email Login:</Form.Label>
          <Form.Check
            className="ml-2 mb-4 form-inline-b3"
            onChange={handleDataChange}
            name="usesInstitutionCourses"
            checked={stateObj && stateObj.data && stateObj.data.email_login ? true : false}
          />
        </Form.Group>
        <Form.Group controlId="useLTIlogin">
          <Form.Label>Use LTI Login:</Form.Label>
          <Form.Check
            className="ml-2 mb-4 form-inline-b3"
            onChange={handleDataChange}
            name="useLTIlogin"
            checked={stateObj && stateObj.data && stateObj.data.lti_login ? true : false}
          />
        </Form.Group>
        <Form.Group controlId="useJWTlogin">
          <Form.Label>Use Institution Courses:</Form.Label>
          <Form.Check
            className="ml-2 mb-4 form-inline-b3"
            onChange={handleDataChange}
            name="useJWTlogin"
            checked={stateObj && stateObj.data && stateObj.data.jwt_login ? true : false}
          />
        </Form.Group>

        <div
          className="btn btn-success btn-myed btn-success-myed"
          onClick={() => commitStateObject()}
        >
          <div className="fa-regular fa-plus fa-fw mr-2" /> Update
        </div>
      </Modal.Body>
    </Modal>
  )
}
// <div style={helpTextStyle}>
//   If checked, use the list defined below instead of the users course memberships to populate the course list
// </div>

EditIssuerModal.propTypes = {
  show: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  issuer: PropTypes.object
}
